module.exports = __webpack_public_path__ + "img/Group.699d3a0e.svg";